import { alpha } from '@gogame/components';

export const TOTAL = 'Total';
export const NETWORKS = 'Networks';
export const APPLICATIONS = 'Applications';
export const CHANNELS = 'Channels';
export const PLATFORMS = 'Platforms';
export const AFFILIATES = 'Affiliates';
export const OWNERS = 'Owners';
export const COUNTRIES = 'Countries';
export const MANAGERS = 'Managers';

export const NETWORK = 'Network';
export const APPLICATION = 'Application';
export const CHANNEL = 'Channel';
export const PLATFORM = 'Platform';
export const AFFILIATE = 'Affiliate';
export const OWNER = 'Owner';
export const COUNTRY = 'Country';
export const MANAGER = 'Manager';
export const NODE_LEVELS = [
  TOTAL,
  NETWORKS,
  APPLICATIONS,
  CHANNELS,
  PLATFORMS,
  AFFILIATES,
  COUNTRIES,
  MANAGERS,
  OWNERS,
];

export const NODE_LEVELS_SINGULAR = [
  TOTAL,
  NETWORK,
  APPLICATION,
  CHANNEL,
  PLATFORM,
  AFFILIATE,
  COUNTRY,
  MANAGER,
  OWNER,
];

export const UA = 1;
export const RE = 2;

export const ACTIVITY_TYPES_LABELS = {
  [UA]: 'UA',
  [RE]: 'RE',
};
export const getActivityTypeColor = (type, theme) => {
  if (Number(type) === UA) {
    return alpha(
      theme.palette.primary.main,
      1 - theme.palette.action.disabledOpacity
    );
  }
  if (Number(type) === RE) {
    return alpha(
      theme.palette.warning.main,
      1 - theme.palette.action.disabledOpacity
    );
  }
};

export const BUDGET = 'budget';
export const COMMENT = 'comment';

// TODO: remove
export const ROAS = 1;
export const ROAS_D0 = 2;
export const ROAS_D7 = 3;
export const ROAS_D30 = 4;
export const REGS = 5;

export const ROAS_D3 = 6;
export const RETENTION_D1 = 7;
export const RETENTION_D7 = 8;
export const RETENTION_D30 = 9;
